import { render, staticRenderFns } from "./AccountSettingsTab.vue?vue&type=template&id=1689c9b4&scoped=true"
import script from "./AccountSettingsTab.vue?vue&type=script&lang=js"
export * from "./AccountSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689c9b4",
  null
  
)

export default component.exports